import { render, staticRenderFns } from "./SupplierRequestItem.vue?vue&type=template&id=959245ae&scoped=true&lang=pug&"
import script from "./SupplierRequestItem.vue?vue&type=script&lang=js&"
export * from "./SupplierRequestItem.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRequestItem.vue?vue&type=style&index=0&id=959245ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959245ae",
  null
  
)

export default component.exports